<section
    class="banner {{ COOKIE_BANNER_CLASS }}"
    i18n-aria-label="@@hermes.accessibility.page.privacy-policy"
    aria-label="information-about-cookies">
    <div class="banner-message">
        @if (privacyPolicyMessage) {
            <p class="banner-message-text">
                {{ privacyPolicyMessage }}
                <h-cookie-link [link]="cookieBanner.link" [linkLabel]="cookieLink"></h-cookie-link>
            </p>
        }
        <p class="banner-message-text">
            {{ cookieMessage }}
            <h-cookie-link [link]="cookieBanner.link" [linkLabel]="cookieLink"></h-cookie-link>
        </p>
    </div>

    <h-close-button class="close-icon" (click)="close()" (keypress.enter)="close()"></h-close-button>
</section>
